import script from "./gamePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./gamePopup.vue?vue&type=script&setup=true&lang=ts"

import "./gamePopup.vue?vue&type=style&index=0&id=d922a274&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d922a274"]])

export default __exports__